import { ArrowLeftOutlined, EditFilled } from '@ant-design/icons'
import { PaginationProps, Steps, Switch } from 'antd'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import '../CampaignSendsNotifications.scss'

import '../../../../components/ExportImgFigma'

import { useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { addCustomerCampaign, editCampaign, getInfoCampaign, getListALLCustomerIdByGroupAndUser, getListCustomersByGroups, getListCustomersUnmatchedByGroups, IChannelListV9, IGroupCampaign, sendInstantlyCampaign } from '../../../../api/campaign/campaignApi'
import { getListFieldsByCustomer, ICustomer, ListField } from '../../../../api/Customer_V2/customerApi_V2'
import { getListAllCustomer, getListConditionMatched, getListConditionUnMatched, getListCustomerByGroup, IVConditionFilterADD } from '../../../../api/groupCustomerV2/groupCustomerV2Api'
import { getListCarCompany, getSLUnitByPermission, ISelectOption, } from '../../../../api/selectOptions/selectOptionsApi'
import { getListTarget, ITarget } from '../../../../api/target/targetApi'
import { convertNationwideValueToTree_V2 } from '../../../../api/unit/unitApi'
import { filterInfoOperatoToConditions } from '../../../../apiSync/customerGroup/customerGroupApi'
import BreadcrumbBlockAdd from '../../../../components/BreadcrumbBlockAdd/BreadcrumbBlockAdd'
import { BATCH_SIZE } from '../../../../env'
import useDebounce from '../../../../hook/useDebounce'
import useLoading from '../../../../hook/useLoading'
import useThrottle from '../../../../hook/useThrottle'
import useToast from '../../../../hook/useToast'
import Layout from '../../../../Layout'
import { FIELDTYPE, NO_VIEW } from '../../../../services/data'
import { selectorCategoryCarIds } from '../../../../store/slices/categoryCarSlice'
import { selectorInfoUser } from '../../../../store/slices/infoUserSlice'
import { convertDateValue, fommatSelectOption, getLastIdList } from '../../../../until'
import { CONDITION, generateColumnsFromCodesAgGridReactGroup, ILastIdGroupCustomer, TypeConditionPreview } from '../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup'
import { CONDITIONGROUP } from '../../../Customers/CustomerGroup/Component/AddGroup/Component/PrivateGroup/AG_PrivateAutomatic'
import { AddType, ISelectedCustomer } from '../../../Customers/CustomerGroup/Component/EditGroup/EditGroup'
import { toAddPayload } from '../../../Customers/CustomerGroup/Component/Modal/ModalAddAndEditCondition'
import { gListOperatorFieldConditionsGroupByInfo } from '../../../Customers/CustomerGroup/untilGroupCustomer'
import { ColumnKey } from '../../../Customers/Tabs/CarListCardClone'
import { FlattenedField } from '../../../CustomersV2/indexV2'
import '../CampaignSendsNotifications.scss'
import { UserValue } from '../Component/SelectCustomSearch'
import { CampaignStep, dataDefaulFilterList, GroupContext, IDataFilterGroupList, InfoCampaignTmp, IVConditionFilterCampaim } from '../Create'
import { ChildRef } from '../Create/Component/InfoCreate'
import { filterInfoOperator, initInfoOperator } from '../Create/Modal/ModalConditionCampaign'
import Detail from './Component/Detail'
import InfoEdit from './Component/InfoEdit'

const DetailAnnouncementCampaign: React.FC = () => {


  useEffect(() => {

    gSLTarget()

    gListFieldsActive()
    // gSLFilterListPhoneCustomer()

    let unmounted = false;
    (async () => {
      const [resCar, resNationwide] = await Promise.all([getListCarCompany(), getSLUnitByPermission(unitTemp)]);
      if (!unmounted && resCar?.status) setSLCategoryCar(fommatSelectOption(resCar.data));
      if (!unmounted && resNationwide?.status) setSLNationwide(convertNationwideValueToTree_V2(resNationwide.data));
    })();

    return () => {
      refSelectionState.current.previousFilterKey = ""

      setInfoCampaign(undefined)
      setIdCustomerLast({ condUnmatched: undefined, condMatched: undefined })

      setSqlTotal(undefined)
      setGroupCustomerSelected([])
      setSelectedIdCustomer([])
      setSelectedIdUnmatchedCustomers(new Set())

      // setChannelList([])

      setDataFilterMatchedCustomers(dataDefaulFilterList)
      setDataFilterUnmatchedCustomers(dataDefaulFilterList)
      setPaginationMatchedCustomers({ current: 1, pageSize: 30, total: 0 })
      setPaginationUnmatchedCustomers({ current: 1, pageSize: 30, total: 0 })

      setListMatchedCustomers([])
      setListUnmatchedCustomers([])
      setInfoIdGroupCustomer([])


    }
  }, [])


  const skipCondMatchedRef = useRef(false);
  const navigate = useNavigate()
  const pushToast = useToast();
  const pushLoading = useLoading()
  const { unitTemp, id } = useSelector(selectorInfoUser) // đợn vị dc chọn
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
  const location = useLocation();
  const { isAutoCampaign, id: campaignId, firstPage, idCustomer } = location.state as { isAutoCampaign: boolean, id: number, firstPage: string, idCustomer: number } || {}

  const childRef = useRef<ChildRef>(null);
  const isFirstLoadUnmatchedRef = useRef(true)
  const isFirstLoadMatchedRef = useRef(true)
  const isFirstLoadALLCustomerRef = useRef(true)
  const [loadingTable, setLoadingTable] = useState(false)

  const runCountRef = useRef(0)
  // bổ sung cho chọn kh mới
  const refSelectionState = useRef({
    // isInitialized: true,
    originalSelectableIds: [] as number[],
    previousFilterKey: "",
  });
  // chỉ truyền customerIds cho listCustomersByGroups khi user thao tác tay:
  // lưu modal thêm KH, hoặc bỏ chọn KH thêm tay ở bảng ngoài
  const shouldSendManualCustomerIdsRef = useRef(false)


  const [sLTarget, setSLTarget] = useState<ITarget[]>([])
  const [sLCategoryCar, setSLCategoryCar] = useState<ISelectOption[]>([]);
  const [sLNationwide, setSLNationwide] = useState<any>()


  const [step, setStep] = useState(CampaignStep.SETUP_INFO);
  const [isPrivateVoucherAdd, setIsPrivateVoucherAdd] = useState<boolean>(false)

  const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])
  const [dataFieldsActive, setDataFieldsActive] = useState<FlattenedField[]>([])
  const [dataFieldsNoActive, setDataFieldsNoActive] = useState<ListField[]>([])

  const [infoCampaign, setInfoCampaign] = useState<InfoCampaignTmp>()
  const [idCustomerLast, setIdCustomerLast] = useState<{ condUnmatched?: number, condMatched?: number }>({ condUnmatched: undefined, condMatched: undefined });


  const [groupCustomerSelected, setGroupCustomerSelected] = useState<IGroupCampaign[]>([])
  const [selectedIdCustomer, setSelectedIdCustomer] = useState<ISelectedCustomer[]>([]);
  const [selectedIdUnmatchedCustomers, setSelectedIdUnmatchedCustomers] = useState<Set<number>>(new Set());
  const [lastId, setLastId] = useState<ILastIdGroupCustomer>()
  const [sqlTotal, setSqlTotal] = useState<string>()


  const [dataFilterMatchedCustomers, setDataFilterMatchedCustomers] = useState<IDataFilterGroupList>(dataDefaulFilterList)
  const [dataFilterUnmatchedCustomers, setDataFilterUnmatchedCustomers] = useState<IDataFilterGroupList>(dataDefaulFilterList)
  const [paginationMatchedCustomers, setPaginationMatchedCustomers] = useState({ current: 1, pageSize: 30, total: 0 });
  const [paginationUnmatchedCustomers, setPaginationUnmatchedCustomers] = useState({ current: 1, pageSize: 30, total: 0 });

  const [listMatchedCustomers, setListMatchedCustomers] = useState<ICustomer[]>([])
  const [listUnmatchedCustomers, setListUnmatchedCustomers] = useState<ICustomer[]>([])

  const [voucherTitle, setVoucherTitle] = useState<UserValue>()

  // dk chọn nhóm
  const [infoIdGroupCustomer, setInfoIdGroupCustomer] = useState<IGroupCampaign[]>([])

  //

  //dk
  const [isAutoCondition, setIsAutoCondition] = useState(false)
  const [isModalLoadingSync, setIsModalLoadingSync] = useState<boolean>(false)

  const [infoOperator, setInfoOperator] = useState<IVConditionFilterCampaim>(initInfoOperator)
  //

  // kh k co dk




  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReactGroup(
      ColumnsMapShow, dataFieldsActive, undefined
    );
  }, [ColumnsMapShow]);

  //dk all
  const tableDataMatchedCustomers: any[] = useMemo(() => {
    return listMatchedCustomers.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [listMatchedCustomers])

  const tableDataUnmatchedCustomers: any[] = useMemo(() => {
    return listUnmatchedCustomers.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [listUnmatchedCustomers])


  const gSLTarget = async () => {
    const result = await getListTarget()
    if (result?.status) {
      setSLTarget(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }


  const gListFieldsActive = async () => {
    const result = await getListFieldsByCustomer(FIELDTYPE.CUSTOMER, 1)
    if (result?.status) {
      const flattenedFields = result.data.flatMap(choice =>
        choice.fields.map(field => ({
          ...field,
          parentId: choice.id,
        }))
      );
      setDataFieldsActive(flattenedFields)
      gListFieldsNotActive()
    }
  }

  const gListFieldsNotActive = async () => {
    const result = await getListFieldsByCustomer(FIELDTYPE.CUSTOMER, 0)
    if (result?.status) {
      setDataFieldsNoActive(result.data)
    }
  }
  // api gọi chi tiétf
  const gInfoCampaign = async (id: number) => {

    pushLoading(true)

    const result = await getInfoCampaign(id)
    if (result?.status) {
      // setVoucherId(result.data?.voucherId)
      setInfoCampaign(convertCampaignDetailToTmp(result.data))

      setGroupCustomerSelected(result.data.groups ?? [])
      // tạm đóng
      // setSelectedIdCustomer(
      //   result.data.customerId?.map(item => ({
      //     customerId: item.id,
      //     addType: item.addType
      //   })) ?? []
      // );
      // bổ sung cho chọn kh mới 06/05
      const customers = result.data.customerId || [];
      const selectedEditableCustomerIdsTmp = customers
        .filter(item => item.addType === 0)
        .map(item => item.id);
      refSelectionState.current.originalSelectableIds = selectedEditableCustomerIdsTmp

      // setInfoOperator(result.data.listFilter)
      if (result.data.auto === CONDITION.YES) {
        setIsAutoCondition(true)


        // if (result.data.listFilter){
        const infoNew = await gListOperatorFieldConditionsGroupByInfo(result.data.listFilter, unitTemp);
        // console.log(infoNew);

        // tạm đóng vì chưa có api
        setInfoOperator(infoNew);
        // }


      }
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)

  }

  const convertCampaignDetailToTmp = (
    data: any
  ): InfoCampaignTmp => {
    return {
      id: data.id,
      title: data.title,
      description: data.description,
      adminId: data.adminId,
      targetId: data.targetId,
      type: data.type,
      role: data.role,
      auto: data.auto,
      code: data.code,
      dateSend: data.dateSend,
      timeSend: data.timeSend,

      // groupCustomerId
      groupCustomerId: data?.groups,

      // customerId
      customerId: data.customers?.map((c: any) => c.id),

      // channelList

      channelList: data.channelList,

      statsByChannel: data?.statsByChannel,

      sendEvent: data?.sendEvent,
      sendInAdvance: data?.sendInAdvance,

      voucherId: data?.voucherId

    }
  }

  //#region  Chọn nhóm kh api
  const gListCustomersByGroups = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {


    const { listCategoryCar, listUnit, search } = dataFilterMatchedCustomers
    const groupCustomerSelectedTmp = groupCustomerSelected?.map(i => i.id) || []
    const selectedIdUnmatchedCustomersTmp = Array.from(selectedIdUnmatchedCustomers)
    const voucherIdTmp = voucherTitle?.value

    // // bổ sung cho chọn kh mới 06/05
    const currentFilterKey = JSON.stringify({
      groupCustomerSelectedTmp,
      unitTemp,
      voucherIdTmp,
      selectedIdUnmatchedCustomersTmp
    });
    const isFirstLoad =
      refSelectionState.current.previousFilterKey === "";
    const hasFilterChanged =
      refSelectionState.current.previousFilterKey !== currentFilterKey;
    // chỉ reset khi đổi filter
    if (!isFirstLoad && hasFilterChanged) {
      refSelectionState.current.originalSelectableIds = [];
    }
    // update key hiện tại
    refSelectionState.current.previousFilterKey =
      currentFilterKey;

    setLoadingTable(true)
    // const campaignIdParam = isFirstLoadMatchedRef.current ? campaignId : undefined


    // chỉ kèm customerIds khi thao tác tay (lưu modal / bỏ chọn ở bảng ngoài)
    const isManualAction = shouldSendManualCustomerIdsRef.current
    shouldSendManualCustomerIdsRef.current = false
    const selectIdUnmatch = isManualAction && selectedIdUnmatchedCustomersTmp.length
      ? selectedIdUnmatchedCustomersTmp
      : undefined

    const result = await getListCustomersByGroups(
      groupCustomerSelectedTmp,
      pageSize, pageCurent, unitTemp, listUnit,
      listCategoryCar, search, selectIdUnmatch, campaignId,
      voucherIdTmp
    )
    if (result?.status) {
      setListMatchedCustomers(result.data.customersFinal)
      // setInfoCampaign({ ...infoCampaign, groupCustomerId: result.data.groups })

      setPaginationMatchedCustomers({ current: pageCurent, total: result.total, pageSize })



      // const isFirstLoad = refSelectionState.current.previousFilterKey === "";
      // const hasFilterChanged = refSelectionState.current.previousFilterKey !== currentFilterKey;
      // if (!isFirstLoad && hasFilterChanged) {
      //   refSelectionState.current.originalSelectableIds = [];
      // }
      // refSelectionState.current.previousFilterKey = currentFilterKey;


      // if (refSelectionState.current.isInitialized) {
      //   refSelectionState.current.isInitialized = false;
      // } else {
      //   refSelectionState.current.originalSelectableIds = [];
      // }
    } else {
      pushToast(result?.message, "warning")
    }
    isFirstLoadALLCustomerRef.current = false
    setLoadingTable(false)
  }, 1000)

  const gListCustomersUnmatchedByGroups = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    const { listCategoryCar, listUnit, search } = dataFilterUnmatchedCustomers
    const selectId = groupCustomerSelected?.map(i => i.id) || []

    // const campaignIdParam = isFirstLoadUnmatchedRef.current ? campaignId : undefined

    setLoadingTable(true)

    const result = await getListCustomersUnmatchedByGroups(
      selectId,
      pageSize, pageCurent, unitTemp, listUnit,
      listCategoryCar, search, campaignId
    )
    if (result?.status) {
      setListUnmatchedCustomers(result.data)
      setPaginationUnmatchedCustomers({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    isFirstLoadUnmatchedRef.current = false
    setLoadingTable(false)
  }, 1000)

  const gListALLCustomerIdByGroupAndUser = useDebounce(async () => {

    const selectedIdUnmatchedCustomersTmp = Array.from(selectedIdUnmatchedCustomers)
    const voucherIdTmp = voucherTitle?.value
    // const campaignIdParam = isFirstLoadALLCustomerRef.current ? campaignId : undefined
    // phải trùng groupIds với gListCustomersByGroups để Preview và data lưu khớp nhau
    const selectId = groupCustomerSelected?.map(i => i.id) || []
    setLoadingTable(true)


    const selectIdUnmatch = isFirstLoadUnmatchedRef.current ? (refSelectionState.current.originalSelectableIds.length ? refSelectionState.current.originalSelectableIds : selectedIdUnmatchedCustomersTmp) : selectedIdUnmatchedCustomersTmp

    // console.log(refSelectionState.current.originalSelectableIds.length)
    // return

    const result = await getListALLCustomerIdByGroupAndUser(
      // selectId, selectIdUnmatch, campaignId,
      // voucherIdTmp

      selectId, undefined, campaignId,
      voucherIdTmp
    )
    if (result?.status) {
      setSelectedIdCustomer(result.data)
      //set cho biên ỏigin 0805
      setSelectedIdUnmatchedCustomers(new Set(refSelectionState.current.originalSelectableIds))
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
    isFirstLoadUnmatchedRef.current = false
  }, 1000)
  //#endregion
  //#region dk nhom api
  // lấy list All
  const gListAllCustomers = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    setLoadingTable(true)

    const {
      listCategoryCar, listUnit, search
    } = dataFilterUnmatchedCustomers

    const lastIdTmp = pageCurent === 1 ? undefined : lastId

    const result = await getListCustomerByGroup(
      permittedCategoryCarIds,
      pageSize, pageCurent, search, unitTemp ?? undefined,
      listUnit, listCategoryCar, undefined, undefined,
      undefined, undefined, lastIdTmp?.noCond
    )
    if (result?.status) {
      setListMatchedCustomers(result.data)
      setPaginationMatchedCustomers({ current: pageCurent, total: result.total, pageSize })

      setLastId({ ...lastId, noCond: getLastIdList(result.data) })
    } else {
      // pushToast(result?.message, "warning")
    }
    setLoadingTable(false)

  }, 1000)


  const gIdSelectAllCustomer = useDebounce(async (isAllCond: boolean = true) => {
    setLoadingTable(true)

    //ds kh có dk lấy hết
    const conditions = isAllCond ? undefined : filterInfoOperatoToConditions(infoOperator)
    const result = await getListAllCustomer(
      permittedCategoryCarIds,
      unitTemp, conditions, undefined, undefined
    )
    if (result?.status) {
      setSelectedIdCustomer(result.data);
      setSqlTotal(result.sqlTotal)
    }

    setLoadingTable(false)
  }, 1000)

  //Lấy ra toàn bộ api thảo và k thỏa dk xem trước dk
  const gSyncListCustomerGroupByFilter = useDebounce(async (
    typeConditionPreview: TypeConditionPreview, pageCurent: number = 1, pageSize: number = 20
  ) => {


    setIsModalLoadingSync(true)
    const conditions = filterInfoOperatoToConditions(infoOperator)
    const listUnmatchedCustomers =
      (typeConditionPreview !== "filter" || !skipCondMatchedRef.current) ?
        Array.from(selectedIdUnmatchedCustomers) :
        undefined
    const dataFilter = typeConditionPreview === "condUnmatched" ? dataFilterUnmatchedCustomers : dataFilterMatchedCustomers;

    const lastIdTmp = pageCurent === 1 ? undefined : lastId

    switch (typeConditionPreview) {
      case "filter": {
        const [resultFilterCondMatched, resultFilterCondUnMatched] = await Promise.all([
          getListConditionMatched(
            permittedCategoryCarIds, conditions,
            pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
            undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
            lastIdTmp?.condMatched
          ),
          getListConditionUnMatched(
            permittedCategoryCarIds, conditions,
            pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
            undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
            lastIdTmp?.condUnmatched
          )
        ])
        if (!resultFilterCondUnMatched) break;
        // const [resultFilterCondMatched,] = await Promise.all([
        //   getListConditionMatched(
        //     permittedCategoryCarIds, conditions,
        //     pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
        //     undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
        //     lastIdTmp?.condMatched
        //   ),
        //   getListConditionUnMatched(
        //       permittedCategoryCarIds, conditions,
        //       pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
        //       undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
        //       lastIdTmp?.condUnmatched
        //   )
        // ])

        if (resultFilterCondMatched.status) {
          setListMatchedCustomers(resultFilterCondMatched.data.dataMatched)
          setPaginationMatchedCustomers({ current: pageCurent, total: resultFilterCondMatched.data.totalMatched, pageSize })
        } else {
          pushToast(resultFilterCondMatched?.message, 'warning')
        }

        if (resultFilterCondUnMatched.status) {
          setListUnmatchedCustomers(resultFilterCondUnMatched.data.dataUnmatched)
          setPaginationUnmatchedCustomers({ current: pageCurent, total: resultFilterCondUnMatched.data.totalUnmatched, pageSize })

        } else {
          pushToast(resultFilterCondUnMatched?.message, 'warning')
        }

        setLastId({
          ...lastId,
          condMatched: getLastIdList(resultFilterCondMatched.data.dataMatched),
          condUnmatched: getLastIdList(resultFilterCondUnMatched.data.dataUnmatched)
        })
        break;
      }
      case "condMatched": {
        const resultFilterCondMatched = await getListConditionMatched(
          permittedCategoryCarIds, conditions,
          pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
          undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
          lastIdTmp?.condMatched
        )
        if (resultFilterCondMatched.status) {
          setListMatchedCustomers(resultFilterCondMatched.data.dataMatched)
          setPaginationMatchedCustomers({ current: pageCurent, total: resultFilterCondMatched.data.totalMatched, pageSize })

          setLastId({ ...lastId, condMatched: getLastIdList(resultFilterCondMatched.data.dataMatched) })
        } else {
          pushToast(resultFilterCondMatched?.message, 'warning')
        }
        break;
      }
      case "condUnmatched": {
        const resultFilterCondUnMatched = await getListConditionUnMatched(
          permittedCategoryCarIds, conditions,
          pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
          undefined, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
          lastIdTmp?.condUnmatched
        )
        if (resultFilterCondUnMatched.status) {
          setListUnmatchedCustomers(resultFilterCondUnMatched.data.dataUnmatched)
          setPaginationUnmatchedCustomers({ current: pageCurent, total: resultFilterCondUnMatched.data.totalUnmatched, pageSize })

          setLastId({ ...lastId, condUnmatched: getLastIdList(resultFilterCondUnMatched.data.dataUnmatched) })
        } else {
          pushToast(resultFilterCondUnMatched?.message, 'warning')
        }
        break;
      }

      default:
        break;
    }

    // Tắt cờ sau khi filter tải xong
    skipCondMatchedRef.current = false;
    setIsModalLoadingSync(false)
  }, 500)

  //#endregion




  const onChangeStep = (value: CampaignStep) => {
    if (value === CampaignStep.SETUP_INFO) {


    } else {
      if (isAutoCondition) {
        const infoOperatorApply = filterInfoOperator(infoOperator)
        if (infoOperatorApply.conditions.length < 1 && infoOperatorApply.typeCondition !== CONDITIONGROUP.ALL) {
          pushToast("Chưa có điêu kiện nào được chọn!", 'warning')
          return
        }
      }
      childRef.current?.changeStepPreview()
    }
  };


  const handleSwitch = (value: boolean) => {
    // setDataFilterMatchedCustomers(dataDefaulFilterList)
    // setIsAutoCondition(value)
    // if (value) {
    //     setInfoIdGroupCustomer([])
    // } else {
    //     setInfoOperator(initInfoOperator)
    // }
  }



  //#region Chọn kh thỏa và không

  //Kh có dk ds xem trước
  const handleChangeCondSelectIdCustomerView: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>> = (value) => {
    // Chuẩn hoá về mảng ISelectedCustomer[]
    const nextArray =
      typeof value === 'function'
        ? value(selectedIdCustomer) // selectedIdCustomerV9: state hiện tại
        : value;

    // Lấy danh sách customerId từ mảng value
    const valueIds = new Set(nextArray.map(v => v.customerId));

    // Giả sử selectedIdNoCondCustomerManual vẫn là Set<number>
    const nextB = new Set(
      [...selectedIdUnmatchedCustomers].filter(x => valueIds.has(x))
    );

    // Cập nhật state chính
    setSelectedIdCustomer(value);

    // Kiểm tra hai Set có giống nhau không
    const areSetsEqual =
      selectedIdUnmatchedCustomers.size === nextB.size &&
      [...selectedIdUnmatchedCustomers].every(v => nextB.has(v));

    if (!areSetsEqual) {
      // user bỏ chọn KH thêm tay ở bảng ngoài -> gọi lại api kèm id còn lại
      shouldSendManualCustomerIdsRef.current = true;
      setSelectedIdUnmatchedCustomers(nextB);
    }
  }

  //Kh có dk

  const handleChangeCondSelectIdCustomerManual = (value: Set<number>) => {
    // 1) Cập nhật danh sách selectedIdCustomerV9 (thêm + xóa theo diff)
    setSelectedIdCustomer(prevList => {
      // Tìm các id bị bỏ chọn (có trong selectedIdUnmatchedCustomers nhưng không còn trong value)
      const removedIds = new Set<number>();
      selectedIdUnmatchedCustomers.forEach(id => {
        if (!value.has(id)) removedIds.add(id);
      });

      // a) XÓA: loại bỏ các item Manual có customerId thuộc removedIds
      const kept = prevList.filter(item => {
        // nếu bị bỏ chọn -> loại
        if (removedIds.has(item.customerId)) return false;
        return true; // còn lại giữ
      });

      // b) THÊM: thêm các id mới từ value nếu chưa có trong kept
      const byId = new Map<number, ISelectedCustomer>(kept.map(c => [c.customerId, c]));
      value.forEach(id => {
        if (!byId.has(id)) {
          byId.set(id, { customerId: id, addType: AddType.Manual });
        }
      });

      return Array.from(byId.values());
    });

    // 2) Đồng bộ lại "bộ chọn" unmatched hiện tại
    // user lưu modal thêm KH thủ công -> gọi lại api kèm id vừa chọn
    shouldSendManualCustomerIdsRef.current = true;
    setSelectedIdUnmatchedCustomers(value);
  };
  //#endregion

  //Kh có dk
  const onPaginationMatchedCustomers: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    if (isAutoCondition) {
      if (infoOperator.typeCondition === CONDITIONGROUP.ALL) {
        gListAllCustomers(pageNumber, pageSize)
      }
      else {
        gSyncListCustomerGroupByFilter("condMatched", pageNumber, pageSize)
      }
    } else {
      gListCustomersByGroups(pageNumber, pageSize)
    }

  }


  // phần ni pagination cho modal thêm khách hàngngf
  const onPaginationUnmatchedCustomers: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    if (isAutoCondition) {
      if (infoOperator.typeCondition === CONDITIONGROUP.ALL) {
        gListAllCustomers(pageNumber, pageSize)
      }
      else {
        gSyncListCustomerGroupByFilter("condMatched", pageNumber, pageSize)
      }
    } else {
      gListCustomersUnmatchedByGroups(pageNumber, pageSize)
    }

  }

  const addCustomersInChunks = async (selectedIdCustomerV9: ISelectedCustomer[], campaignId: number) => {
    for (let i = 0; i < selectedIdCustomerV9.length; i += BATCH_SIZE) {
      const chunk = selectedIdCustomerV9.slice(i, i + BATCH_SIZE);

      let success = false;
      let retryCount = 0;

      while (!success) {
        try {
          await addCustomerCampaign(campaignId, chunk);
          success = true;
        } catch (error) {
          retryCount++;
          console.error(`Chunk ${i / BATCH_SIZE + 1} failed (retry ${retryCount})`, error);

          // delay trước khi retry
          await new Promise(r => setTimeout(r, 1000));
        }
      }

      // delay giữa các batch
      await new Promise(r => setTimeout(r, 50));
    }
    navigate('/marketing/campaign-sends-notifications')
  };

  const onFinish = useThrottle(async () => {
    const {
      title, targetId, channelList, type,
      role, auto,
      groupCustomerId, dateSend, timeSend, sendHour,
      sendEvent, sendInAdvance, description
    } = infoCampaign ?? {}

    if (!title || targetId === undefined || type === undefined || role === undefined) {
      pushToast("Thiếu thông tin campaign", "warning");
      return;
    }

    const channelListTmp: IChannelListV9[] =
      channelList?.map(item => ({
        channelId: item.channelId,
        brandId: item.brandId ?? 0,
        notificationTemplateId: item.notificationTemplateId ?? 0,
      })) ?? [];

    const autoTmp = isAutoCondition ? 1 : 0
    const timeSendTmp = timeSend ?? sendHour

    const filteredInfoOperatorADD = toAddPayload(infoOperator)

    const listFilterGroup: IVConditionFilterADD = {
      typeCondition: filteredInfoOperatorADD.typeCondition,

      conditions: filteredInfoOperatorADD.conditions.map(condition => ({
        ...condition,

        value: convertDateValue(condition.value),
      })),
    };
    const voucherId = voucherTitle?.value

    //20/03
    pushLoading(true)
    const result = await editCampaign(
      campaignId, title, targetId, channelListTmp,
      type, role, autoTmp,
      groupCustomerId, dateSend, timeSendTmp,
      sendEvent, sendInAdvance, listFilterGroup, description,
      voucherId
    )
    if (result?.status) {
      pushToast(result?.message, "success")

      // Voucher cá nhân: đồng bộ lại danh sách customer ID trước khi lưu,
      // tránh phụ thuộc state đã bị reset/debounce
      let customersToAdd = selectedIdCustomer
      if (voucherId && !isAutoCondition) {
        const groupIdsTmp = groupCustomerSelected?.map(i => i.id) || []
        const selectIdUnmatchTmp = Array.from(selectedIdUnmatchedCustomers)
        const resultIds = await getListALLCustomerIdByGroupAndUser(
          // groupIdsTmp, selectIdUnmatchTmp, campaignId, voucherId
          groupIdsTmp, undefined, campaignId, voucherId

        )
        if (resultIds?.status && resultIds.data?.length) {
          customersToAdd = resultIds.data
        }
      }
      if (!isPrivateVoucherAdd) {
        await addCustomersInChunks(customersToAdd, campaignId)
      }

      await sendInstantlyCampaign(campaignId);
      navigate(-1)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 5000)

  useEffect(() => {
    const codes = dataFieldsActive.map(f => f.fieldCode)
    setColumnsMapShow(codes)
  }, [dataFieldsActive])


  //#region  Kh có dk useEffect

  //Kh có dk khi thêm tự động


  //Kh có dk khi thêm tự động
  useEffect(() => {
    if (isAutoCondition) {
      setIsModalLoadingSync(true)
      gSyncListCustomerGroupByFilter("condUnmatched")
    } else {
      if (groupCustomerSelected.length) {
        gListCustomersUnmatchedByGroups()
      }
    }
  }, [dataFilterUnmatchedCustomers])


  //kh có dk khi bật tắt tự động thêm đk clear data
  useEffect(() => {
    if (!isAutoCondition)
      setInfoOperator(initInfoOperator)
  }, [isAutoCondition])

  //Kh có dk  thay đổi dk
  useEffect(() => {
    // bất tắt switch áp dụng điều kiện
    const conditions = infoOperator.conditions.filter((a) => a.isAdd === true)
    // hàm xử lý khi thay đổi đk thành AND - OR
    if (conditions.length) {
      setIsModalLoadingSync(true)

      // Bật cờ để không cho A tự động bắn condMatched do reset
      skipCondMatchedRef.current = true;

      //Xóa các trường đã chọn khi thay đổi đk
      setSqlTotal(undefined)
      setSelectedIdCustomer([])
      setSelectedIdUnmatchedCustomers(new Set())

      gSyncListCustomerGroupByFilter("filter")
      gIdSelectAllCustomer(false)
    }
  }, [infoOperator.conditions])

  const isResettingRef = useRef(false)
  // gọi api lấy all
  useEffect(() => {
    if (infoOperator.typeCondition === CONDITIONGROUP.ALL) {
      gIdSelectAllCustomer()
      gListAllCustomers()
    }
  }, [unitTemp, infoOperator.typeCondition])
  //#endregion

  //#region  Chọn nhóm kh useEffect thay đổi nhóm
  useEffect(() => {
    isResettingRef.current = true

    setDataFilterMatchedCustomers(dataDefaulFilterList)
    setDataFilterUnmatchedCustomers(dataDefaulFilterList)

    setPaginationMatchedCustomers({ current: 1, pageSize: 30, total: 0 })
    setPaginationUnmatchedCustomers({ current: 1, pageSize: 30, total: 0 })

    //15/5
    setSqlTotal(undefined)
    // setSelectedIdCustomer([])
    setSelectedIdUnmatchedCustomers(new Set())

    if (groupCustomerSelected.length) {
      setSelectedIdCustomer([])
      gListALLCustomerIdByGroupAndUser()
      gListCustomersUnmatchedByGroups()
    } else {
      setListMatchedCustomers([])
      setListUnmatchedCustomers([])


      // tạm đóng 7/6
      setInfoCampaign({ ...infoCampaign, groupCustomerId: undefined })
    }

    // mở khóa sau 1 tick
    setTimeout(() => {
      isResettingRef.current = false
    })
  }, [groupCustomerSelected])

  ////tắt AI 0705
  // useEffect(() => {
  //   if (skipCondMatchedRef.current) return;

  //   if (groupCustomerSelected.length) {
  //     runCountRef.current += 1
  //     if (runCountRef.current <= 2) return
  //   }

  //   if (isAutoCondition) {
  //     setIsModalLoadingSync(true)
  //     gSyncListCustomerGroupByFilter("condMatched")
  //   } else {
  //     if (groupCustomerSelected.length || voucherTitle?.value) {
  //       gListCustomersByGroups()
  //     } else {
  //       //0705
  //       setListMatchedCustomers([])
  //       setListUnmatchedCustomers([])

  //       setInfoCampaign({ ...infoCampaign, groupCustomerId: undefined })
  //     }
  //   }
  // }, [
  //   dataFilterMatchedCustomers, groupCustomerSelected, selectedIdUnmatchedCustomers, voucherTitle
  // ])

  // bật AI 0705
  useEffect(() => {

    if (skipCondMatchedRef.current) return;
    //15/5
    setSqlTotal(undefined)

    // tránh gọi lần đầu khi load data edit
    if (groupCustomerSelected.length) {
      runCountRef.current += 1;

      if (runCountRef.current <= 2) return;
    }

    if (isAutoCondition) {

      setIsModalLoadingSync(true);

      gSyncListCustomerGroupByFilter("condMatched");

    } else {
      gListCustomersByGroups();

      if (groupCustomerSelected.length || voucherTitle?.value) {

        // gListCustomersByGroups();

      } else {

        setListMatchedCustomers([]);
        setListUnmatchedCustomers([]);

        setInfoCampaign({
          ...infoCampaign,
          groupCustomerId: undefined
        });
      }
    }

  }, [
    dataFilterMatchedCustomers, groupCustomerSelected, selectedIdUnmatchedCustomers, voucherTitle,
    isAutoCondition
  ]);

  //0705 gọi api ds nếu từ mục tiêu voucher qua mục tiêu khác
  //tắt AI 0705
  //  useEffect(() => {
  //   if (!isAutoCondition) {
  //     gListCustomersByGroups()
  //   }
  // }, [dataFilterMatchedCustomers, groupCustomerSelected, voucherTitle])
  //#endregion

  //#region: location
  useEffect(() => {
    setIsAutoCondition(isAutoCampaign)
  }, [isAutoCampaign])

  useEffect(() => {
    if (campaignId) {
      gInfoCampaign(campaignId)
      if (location.state.action === 'access') {
        setStep(CampaignStep.PREVIEW)
      } else {
        setStep(CampaignStep.SETUP_INFO)
      }
    } else {
      navigate(-1)
    }
  }, [location])

  return (
    <GroupContext.Provider
      value={{
        step, voucherTitle,
        ColumnsMapShow, dataFieldsActive,
        sLCategoryCar, sLNationwide, sLTarget,
        setVoucherTitle

      }}>
      <Layout contentClassName='customer-add-content'>


        <BreadcrumbBlockAdd
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: <Link to="/marketing/campaign-sends-notifications">Marketing</Link>, },
            { title: <Link to="/marketing/campaign-sends-notifications">Chiến dịch gửi thông báo</Link>, },
            { title: `${location.state.action === 'access' ? 'Chi tiết chiến dịch' : 'Chỉnh sửa chiến dịch'}`, },
          ]}
          className="gutter-block-end"
        />
        <div className="app-breadcrumb-title">

          <Link
            className="icon"
            to={firstPage ?? '/marketing/campaign-sends-notifications'}
            state={{
              id: idCustomer,
            }}
          >
            <ArrowLeftOutlined />
          </Link>

          <div className="title">{location.state.action === 'access' ? 'Chi tiết chiến dịch' : 'Chỉnh sửa chiến dịch'}</div>


          {
            location.state.action === 'access' ?
              infoCampaign?.role !== 0 &&
              <button
                className="custom-page-css ml-auto rounded bg-096DD9 text-white border-1890FF py-2 px-4"
                onClick={() => navigate(
                  '/marketing/campaign-sends-notifications/edit',
                  { state: { id: infoCampaign?.id, action: 'edit', isAutoCampaign: infoCampaign?.auto } }
                )}
              >
                Sửa chiến dịch
                <EditFilled color='#ffffff' className='pl-2' />

              </button>
              :
              step === CampaignStep.SETUP_INFO ?
                <button
                  className={
                    `custom-page-css ml-auto rounded bg-096DD9 text-white border-1890FF py-2 px-4`
                  }
                  onClick={() => onChangeStep(CampaignStep.PREVIEW)}
                >
                  Tiếp theo
                </button> :
                <button
                  className="custom-page-css ml-auto rounded bg-096DD9 text-white border-1890FF py-2 px-4"
                  onClick={() => onFinish()}
                >
                  Lưu
                </button>
          }

        </div>
        {
          location.state.action !== 'access'
          &&
          <div className="custom-page-css w-full flex items-center justify-center ">
            <div className="custom-page-css w-50-percent">
              <Steps
                current={step}
                onChange={onChangeStep}
                items={[
                  {
                    title: 'Thiết lập thông tin',
                    onClick: () => setStep(CampaignStep.SETUP_INFO)
                  },
                  {
                    title: 'Xem trước chiến dịch',
                  }
                ]}
                size="small"
                className="custom-steps"
              />
            </div>

          </div>
        }
        {
          location.state.action !== 'access' &&
          <div className="custom-page-css flex items-center justify-end gap-2 pt-4">
            <span className='custom-page-css font-medium lh-24 fsz-16 font-regular whiteSpace-nowrap'>Tự động thêm khách hàng có cùng điều kiện</span>
            <Switch
              checked={isAutoCondition}
            // onClick={() => handleSwitch(!isAutoCondition)}
            />
          </div>
        }
        <div className={step === CampaignStep.SETUP_INFO ? '' : 'd-none'}>
          <InfoEdit
            ref={childRef}

            loading={loadingTable}
            refSelectionState={refSelectionState}

            memoizedColumnDefs={memoizedColumnDefs}

            infoCampaign={infoCampaign}

            groupCustomerSelected={groupCustomerSelected}
            selectedIdCustomer={selectedIdCustomer}
            selectedIdUnmatchedCustomers={selectedIdUnmatchedCustomers}

            dataFilterMatchedCustomers={dataFilterMatchedCustomers}
            dataFilterUnmatchedCustomers={dataFilterUnmatchedCustomers}
            paginationMatchedCustomers={paginationMatchedCustomers}
            paginationUnmatchedCustomers={paginationUnmatchedCustomers}

            listMatchedCustomers={tableDataMatchedCustomers}
            listUnmatchedCustomers={tableDataUnmatchedCustomers}

            setStep={setStep}
            setIsPrivateVoucherAdd={setIsPrivateVoucherAdd}

            setInfoCampaign={setInfoCampaign}
            setGroupCustomerSelected={setGroupCustomerSelected}
            setSelectedIdCustomer={handleChangeCondSelectIdCustomerView}
            setSelectedIdUnmatchedCustomers={handleChangeCondSelectIdCustomerManual}

            setDataFilterMatchedCustomers={setDataFilterMatchedCustomers}
            setDataFilterUnmatchedCustomers={setDataFilterUnmatchedCustomers}

            onPaginationMatchedCustomers={onPaginationMatchedCustomers}
            onPaginationUnmatchedCustomers={onPaginationUnmatchedCustomers}

            //dk
            isAutoCondition={isAutoCondition}
            infoOperator={infoOperator}
            setInfoOperator={setInfoOperator}

          //
          />
        </div>

        <div className={step === CampaignStep.PREVIEW ? '' : 'd-none'}>
          <Detail
            location={location}
            step={step}
            memoizedColumnDefs={memoizedColumnDefs}
            loading={loadingTable}

            infoCampaign={infoCampaign}
            sqlTotal={sqlTotal}
            listMatchedCustomers={tableDataMatchedCustomers}
            dataFilterMatchedCustomers={dataFilterMatchedCustomers}

            setInfoCampaign={setInfoCampaign}

            paginationMatchedCustomers={paginationMatchedCustomers}

            setDataFilterMatchedCustomers={setDataFilterMatchedCustomers}

            onPaginationMatchedCustomers={onPaginationMatchedCustomers}
            infoOperator={infoOperator}
            selectedIdCustomer={selectedIdCustomer}
          />
        </div>

      </Layout>
    </GroupContext.Provider>
  )
}

export default React.memo(DetailAnnouncementCampaign)
export const useCustomerGroupContext = () => useContext(GroupContext)!;
